export function formatPostnummer(
  value: number | string | null | undefined,
): string {
  if (!value) return "";

  return value.toString().padStart(4, "0");
}
